<script [src]="paypalScriptSrc" defer></script>
@if (organiser$ | async; as organiser){
    <div class="relative my-3 border-slate-200 dark:border-slate-500 border bg-slate-100 dark:bg-slate-700 text-lrpTicketBlack dark:text-stone-300 rounded-xl p-4 shadow-md">
        <div class="flex justify-between">
            <h2 class="text-lg">Edit Organiser - {{ organiser.name }}</h2>
            @if (organiser.image){
                <img [src]="organiser.image?.url" alt="" class="max-h-12">
            }
        </div>
        
        <div class="grid grid-cols-2 gap-4" [formGroup]="organiserForm">
            <div class="flex flex-col gap-6">
                <div class="flex flex-col gap-2">
                    <label for="organiserName">Organiser Name</label>
                    <input id="organiserName" type="text" formControlName="organiserName">
                </div>
                <div class="flex flex-col gap-2">
                    <label for="contact">Contact Details</label>
                    <input id="contact" type="text" formControlName="contact" placeholder="Phonenumber / E-mail address">
                </div>
                <div class="flex flex-col gap-2">
                    <label for="Image">Update Image</label>
                    <p-fileupload name="file" [headers]="getHeaders" [url]="apiUrl" (onUpload)="onUpload($event)" [multiple]="false" accept="image/*" maxFileSize="1000000" mode="advanced" [auto]="true">
                        <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
                            <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
                                <div class="flex gap-2">
                                    <button (click)="choose($event, chooseCallback)" class="primaryButton button-small">Select Image</button>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #empty>
                            <div class="text-sm">Drag and drop files to here to upload.</div>
                        </ng-template>
                    </p-fileupload>
                </div>
            </div>
            <div class="flex flex-col">
                <div class="flex flex-col gap-2">
                    <label for="terms">Terms & Conditions</label>
                    <p-editor class="h-52" formControlName="terms" />
                </div>
            </div>
        </div>
        <div class="my-3">
            <p>Link to one of the supported payment providers to enable payments for your events</p>
            <div class="flex gap-4 justify-center">
                    <button class="outline-button small my-2" [disabled]="getPaymentProvider('PayPal', organiser.paymentProvider)" (click)="displayPaypalModal = true">
                        <fa-icon [icon]="['fab','paypal']"/><p>{{ getPaymentProvider('PayPal', organiser.paymentProvider) ? 'Connected To PayPal' : 'Connect To PayPal' }}</p>
                        @if (getPaymentProvider('PayPal', organiser.paymentProvider)){
                            <p class="text-xs">{{ getPaymentProvider('PayPal', organiser.paymentProvider)?.providerMerchantID }}</p>
                        }
                    </button>
                    <button class="outline-button small my-2" disabled title="Coming Soon">
                        <fa-icon [icon]="['fab','stripe-s']"/><p>{{ getPaymentProvider('Stripe', organiser.paymentProvider) ? 'Connected To Stripe' : 'Connect To Stripe' }}</p>
                        @if (getPaymentProvider('Stripe', organiser.paymentProvider)){
                            <p class="text-xs">{{ getPaymentProvider('Stripe', organiser.paymentProvider)?.providerMerchantID }}</p>
                        }
                    </button>
            </div>
            
        </div>
        <button class="primaryButton small w-32">Save</button>
    </div>

<p-dialog [modal]="true" [dismissableMask]="true" [(visible)]="displayPaypalModal" header="Connect To PayPal" [style]="{ width: '60%' }" class="text-sm" >
    <p class="mb-2">PayPal offers one of the worlds most recognised payment solutions.</p>
    <p>By linking your PayPal account to <span class="text-lrpTicketBlue font-semibold tracking-wider">LRP</span><span class="font-semibold"> Tickets</span> you allow us to request payments on your behalf, and give you the ability to manage payments and refunds directly alongside bookings.</p>

    <div class="flex flex-col gap-3 my-5 mx-10" [formGroup]="paypalForm">
        <label for="paypal">Your PayPal Account</label>
        <input type="email" id="paypal" placeholder="Your PayPal Account E-mail Address" formControlName="account">
    </div>
    <p>You will now be directed to PayPal where you will be asked to give us permissions to:</p>
    <ul class="list-disc ps-8">
        <li>Request payments on your behalf</li>
        <li>Issue refunds</li>
    </ul>
    <button class="primaryButton small mb-2 mt-6 w-full" (click)="connectToPayPal()"><fa-icon [icon]="['fab','paypal']"/> Connect To PayPal</button>
    <div id="paypal-container"></div>
</p-dialog>
}